import React from 'react';
import { Link } from 'react-router-dom';
import { useHOA } from '../contexts/HOAContext';
import { hoaProfile } from '../lib/hoaProfile';

const ContactPage = () => {
  const profile = hoaProfile(useHOA().hoa);
  const supportEmail = profile.supportEmail;
  const hoaName = profile.name;

  return (
    <div className="min-h-screen bg-main-bg">
      <header className="bg-sidebar-bg text-white">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>arrow_back</span>
            <span className="text-sm font-semibold">{hoaName}</span>
          </Link>
        </div>
      </header>

      <main className="max-w-lg mx-auto px-6 py-16">
        <section className="bg-section-bg p-8 rounded-[2.5rem]">
          <div className="bg-white rounded-2xl p-8 warm-tactile-shadow border border-amber-100/30 text-center">
            <div className="w-16 h-16 bg-section-bg rounded-2xl flex items-center justify-center mx-auto mb-6">
              <span className="material-symbols-outlined text-secondary" style={{ fontSize: '36px' }}>mail</span>
            </div>
            <h1 className="text-3xl font-bold tracking-tight text-primary-dark mb-3">Contact us</h1>
            <p className="text-base font-medium text-primary-dark/80 mb-8 leading-relaxed">
              Questions about the member portal, your account, or your information? Send us an email and we will reply.
            </p>
            <a
              href={`mailto:${supportEmail}`}
              className="inline-flex items-center gap-2 bg-secondary text-white px-8 py-3.5 rounded-full font-bold hover:brightness-110 active:scale-95 transition-all"
            >
              <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>send</span>
              Email {supportEmail}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ContactPage;
